import React from "react";
import { connect } from "react-redux";
import * as actions from "./../../actions";
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import { instanceOf } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';
import Button from "@material-ui/core/Button";

import Dialog from "@material-ui/core/Dialog";
import Slide from "@material-ui/core/Slide";

const styles = theme => ({
  root:{
    fontFamily:"Kanit",


    position:"relative",
    padding: theme.spacing.unit *3,
    paddingTop: 44,

  },

});

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

class AboutCookies extends React.Component  {
  constructor(props){
    super(props)

    this.state = {
      isActive: this.props.cookiesInfoDialog,
      cookieConsent: this.props.cookies.get("cookie_consent")
    }
  }


  static propTypes = {
    cookies: instanceOf(Cookies).isRequired,
    classes: PropTypes.object.isRequired,
  };

  componentDidUpdate(prevProps){
    console.log(this.props.cookiesInfoDialog)
    if(prevProps.cookiesInfoDialog !== this.props.cookiesInfoDialog)this.setState({isActive: this.props.cookiesInfoDialog})
  }

  goBack = ()=>{
    this.props.showCookiesInfo(false)
  }

  render(){

      const { classes} = this.props
      return (
        <Dialog
          fullScreen
          open={this.state.isActive}
          onClose={this.toggleCompanyInfoDialog}
          TransitionComponent={Transition}
        >
          <div className={classes.root}>
            <h1>Cookies In Use on This Site</h1>

            <h2>Cookies and how they Benefit You</h2>

            <p>Our website uses cookies, as almost all websites do, to help provide you with the best experience we can.
            Cookies are small text files that are placed on your computer or mobile phone when you browse websites</p>
            <p>Our cookies help us:</p>

            <ul>
            <li>Make our website work as you'd expect</li>
            <li>Save you having to login every time you visit the site</li><li>Remember your settings during and between visits</li><li>Improve the speed/security of the site</li>
            <li>Personalise our site to you to help you get what you need faster</li><li>Continuously improve our website for you</li><li>Make our marketing more efficient (ultimately helping us to offer the service we do at the price we do)</li></ul>

            <p>We do not use cookies to:</p>

            <ul>
            <li>Collect any personally identifiable information (without your express permission)</li><li>Collect any sensitive information (without your express permission)</li><li>Pass personally identifiable data to third parties</li><li>Pay sales commissions</li></ul>

            <p>You can learn more about all the cookies we use below</p>

            <h2>Granting us permission to use cookies</h2>

            <p>If the settings on your software that you are using to view this website (your browser) are adjusted to accept cookies we take this, and your continued use of our website, to mean that you are fine with this.  Should you wish to remove or not use cookies from our site you can learn how to do this below, however doing so will likely mean that our site will not work as you would expect.</p>

            <h2>More about our Cookies</h2>

            <h3>Website Function Cookies</h3>

            <h3>Our own cookies</h3>

            <p>We use cookies to make our website work including:</p>

            <ul>
            <li>Determining if you are logged in or not</li>
            <li>Remembering if you have accepted our terms and conditions</li>
            <li>Tailoring content to your needs</li>
            <li>Remembering if we have already asked you certain questions (e.g. you declined to use our app or take our survey)</li>
            </ul>

            <p>There is no way to prevent these cookies being set other than to not use our site.</p>




            <h3>Anonymous Visitor Statistics Cookies</h3>

            <p>We use cookies to compile visitor statistics such as how many people have visited our website, what type of technology they are using (e.g. Mac or Windows which helps to identify when our site isn't working as it should for particular technologies), how long they spend on the site, what page they look at etc.  This helps us to continuously improve our website. These so called “analytics” programs also tell us if , on an anonymous basis, how people reached this site (e.g. from a search engine) and whether they have been here before helping us to put more money into developing our services for you instead of marketing spend. </p>

            <p>We use:</p>

            <ul>
            </ul>

            <h3>Advertising Cookies</h3>

            <p>Cookies are widely used in online advertising. Neither us, advertisers or our advertising partners can gain personally identifiable information from these cookies. </p>
            <p>You can learn more about online advertising at http://www.youronlinechoices.com .  You can opt-out of almost all advertising cookies at http://www.youronlinechoices.com/uk/your-ad-choices although we would prefer that you didn’t as ultimately adverts help keep much of the internet free. It is also worth noting that opting out of advertising cookies will not mean you won't see adverts, just simply that they won't be tailored to you any longer.</p>

            <p>We use:</p>
            <ul>
            </ul>


            <h3>Remarketing Cookies</h3>

            <p>You may notice that sometimes after visiting a site you see increased numbers of adverts from the site you visited.  This is because advertisers, including ourselves pay for these adverts.  The technology to do this is made possible by cookies and as such we may place a so called “remarketing cookie” during your visit.  We use these adverts to offer special offers etc to encourage you to come back to our site.  Don't worry we are unable to proactively reach out to you as the whole process is entirely anonymised.  You can opt out of these cookies at anytime as explained above.</p>

            <ul>
            </ul>


            <h3>Turning Cookies Off</h3>

            <p>You can usually switch cookies off by adjusting your browser settings to stop it from accepting cookies (Learn how <a href=" http://www.attacat.co.uk/resources/cookies/how-to-ban">here</a>).  Doing so however will likely limit the functionality of our's and a large proportion of the world's websites as cookies are a standard part of most modern websites</p>
            <p>It may be that you concerns around cookies relate to so called "spyware".  Rather than switching off cookies in your browser you may find that anti-spyware software achieves the same objective by automatically deleting cookies considered to be invasive.  Learn more about <a href="http://www.attacat.co.uk/resources/cookies/how-to-control-your-online-privacy">managing cookies with antispyware software</a>.</p>



            <Button variant="contained" color="primary" onClick={this.goBack} fullWidth>Nazaj</Button>
          </div>

        </Dialog>
      );
  }

};

const mapStateToProps = ({ cookiesInfoDialog }) => {
  return {
    cookiesInfoDialog
  };
};

export default connect(mapStateToProps, actions)(withStyles(styles)(withCookies(AboutCookies)));



// WEBPACK FOOTER //
// ./src/components/main/AboutCookies.js